<template>
    <div class="inner-main">

        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="item" v-for="data in list" :key="data.id">
                <div class="news" @click="goDetail(data.id)">
                    <div class="top">
                        <div class="dot"></div>
                        <div class="date">
                            {{getDate(data.publishDate)}}
                        </div>
                    </div>

                    <div class="title">
                        {{data.newsTitle}}

                    </div>
                    <!-- <div class="content">
                        {{getSubContent(data.newsContent)}}
                    </div> -->
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
import webService from "@network/webService";
import common from "@common/common";
export default {
    data() {
        return {
            list: [],
            loading: false,
            finished: false,
            currentPage: 0,
        };
    },
    props: {
        dataType: {
            type: Number,
            default: 3,
        },
        relatedId: {
            type: String,
            default: '',
        },
    },
    components: {},

    computed: {},

    mounted() {},

    methods: {
        onLoad() {
            let searchModel = {
                PageSize: 10,
                Page: this.currentPage,
            };
            if (this.dataType == common.relationshipSearchTypeEnum.Invested) {
                webService
                    .getInvestedNewsList(this.relatedId, searchModel)
                    .then((res) => {
                        console.log(res);
                        common.procssData(this, res.data);
                    });
            } else {
                    webService
                    .getOrgNewsList(this.relatedId, searchModel)
                    .then((res) => {
                        console.log(res);
                        common.procssData(this, res.data);
                    });
            }
        },
        getSubContent(cont) {
            let contentsArr = JSON.parse(cont);
            for (let i = 0; i < contentsArr.length; i++) {
                let obj = contentsArr[i];
                if (common.isEmpty(obj.image) && !common.isEmpty(obj.content)) {
                    return obj.content;
                }
            }
        },
        getDate(date) {
            if (!common.isEmpty(date)) {
                return this.$moment(date).format("yyyy/MM/DD");
            } else {
                return "None";
            }
        },
        goDetail(id) {
            this.$router.push({
                path: "/newsDetail",
                query: {
                    id: id,
                    type: 0,
                },
            });
        },
    },
};
</script>
<style lang='less' scoped>
.inner-main {
    padding: 1.125rem;
    padding-top: 1.875rem;
}

.item:not(:nth-of-type(1)) {
    padding-top: 20px;
}
.item {
    border-left: 1px solid #dedede;
    .news {
        padding: 0.625rem 0.625rem 0.625rem 0.625rem;
        position: relative;
        .top {
            position: absolute;
            display: flex;
            top: -10px;
            left: -5px;
            .dot {
                background: #dedede;
                border-radius: 50%;
                height: 0.625rem;
                width: 0.625rem;
                // left: 0;
                // top: 7px;
                // transform: translateX(-50%);
            }
            .date {
                position: absolute;
                left: 16px;
                top: -7px;
                font-size: 12px;
                color: #7d7d7d;
            }
        }
    }

    .title {
        font-size: 16px;
        font-weight: 550;
        color: #464646;
        // height: 38px;
        line-height: 30px;
    }

    .content {
        padding-top: 10px;
        font-size: 14px;
        line-height: 20px;

        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/content/invested/RelatedNews.vue